import { Component } from '@theme/component';
import { ThemeEvents } from '@theme/events';

/** Keeps article copy in sync with the server-rendered selected variant. */
class VariantContent extends Component {
  #section;

  connectedCallback() {
    super.connectedCallback();
    this.#section = this.closest('.shopify-section');
    this.#section?.addEventListener(ThemeEvents.variantUpdate, this.updateContent);
  }

  disconnectedCallback() {
    this.#section?.removeEventListener(ThemeEvents.variantUpdate, this.updateContent);
    super.disconnectedCallback();
  }

  updateContent = (event) => {
    if (String(event.detail.data.productId) !== this.dataset.productId) return;
    const replacement = event.detail.data.html.querySelector(
      `variant-content[data-product-id="${this.dataset.productId}"][data-field="${this.dataset.field}"]`
    );
    if (!replacement) return;
    const previous = new Map(Array.from(this.querySelectorAll?.('.hfx-specs tr') ?? [], row => [
      row.querySelector('th')?.textContent.trim(), row.querySelector('td')?.textContent.trim(),
    ]));
    this.replaceChildren(...Array.from(replacement.childNodes, node => node.cloneNode(true)));
    if (!this.hasAttribute?.('data-highlight-changes')) return;
    for (const row of this.querySelectorAll('.hfx-specs tr')) {
      const key = row.querySelector('th')?.textContent.trim();
      if (previous.get(key) !== row.querySelector('td')?.textContent.trim()) row.classList.add('hfx-spec-changed');
    }
    const panel = this.querySelector('.hfx-desc');
    if (panel && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      panel.animate([{ opacity: 0.5 }, { opacity: 1 }], { duration: 250 });
    }
  };
}

if (!customElements.get('variant-content')) customElements.define('variant-content', VariantContent);
